import { render, staticRenderFns } from "./editBindUser.vue?vue&type=template&id=dfbfeb16&scoped=true"
import script from "./editBindUser.vue?vue&type=script&lang=js"
export * from "./editBindUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbfeb16",
  null
  
)

export default component.exports